import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [needsApproval, setNeedsApproval] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if redirected due to session expiration
    if (localStorage.getItem('sessionExpired') === 'true') {
      setSessionExpired(true);
      localStorage.removeItem('sessionExpired');
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setNeedsApproval(false);
    setSessionExpired(false);
    setLoading(true);

    try {
      await login(username, password);
      navigate('/');
    } catch (err: any) {
      const errorData = err.response?.data;
      if (errorData?.needsApproval) {
        setNeedsApproval(true);
      }
      setError(errorData?.message || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>BRK Material System</h1>
        <h2>Anmelden</h2>
        {sessionExpired && (
          <div className="info-message">
            Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.
          </div>
        )}
        {needsApproval && (
          <div className="warning-message">
            ⏳ Ihr Account wartet auf Freigabe durch einen Administrator. Bitte haben Sie etwas Geduld.
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Benutzername</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              minLength={6}
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Wird angemeldet...' : 'Anmelden'}
          </button>
        </form>
        <div className="register-link">
          <p>Noch kein Konto? <Link to="/register">Hier registrieren</Link></p>
        </div>
      </div>
    </div>
  );
}
